export const LOAD_SHAREHOLDERS_STARTED = 'LOAD_SHAREHOLDERS_STARTED';
export const LOAD_SHAREHOLDERS_SUCCEEDED = 'LOAD_SHAREHOLDERS_SUCCEEDED';
export const LOAD_SHAREHOLDERS_FAILED = 'LOAD_SHAREHOLDERS_FAILED';

export const LOAD_SHAREHOLDERS_SUMMARY_SUCCEEDED = 'LOAD_SHAREHOLDERS_SUMMARY_SUCCEEDED';

export const LOAD_PARTNER_DETAILS_STARTED = 'LOAD_PARTNER_DETAILS_STARTED';
export const LOAD_PARTNER_DETAILS_SUCCEEDED = 'LOAD_PARTNER_DETAILS_SUCCEEDED';
export const LOAD_PARTNER_DETAILS_FAILED = 'LOAD_PARTNER_DETAILS_FAILED';

export const UPDATE_SHAREHOLDERS_STARTED = 'UPDATE_SHAREHOLDERS_STARTED';
export const UPDATE_SHAREHOLDERS_SUCCEEDED = 'UPDATE_SHAREHOLDERS_SUCCEEDED';
export const UPDATE_SHAREHOLDERS_FAILED = 'UPDATE_SHAREHOLDERS_FAILED';
